module.exports = __webpack_public_path__ + "static/media/space-station-moon-alt.550c0ef0.svg";